<template>
    <div class="vip">
        <div class="vip-header">
            <div class="left">
                <p class="title">
                    <img src="../../../../images/vip/vip_icon1.png" alt="">
                    <span>住逻辑VIP</span>
                </p>
                <p class="due-time" v-if="user.isVip">
                   <span class="fee-info">{{user.vipEndTime | setTimeDate}} 到期 </span><a :href="`${baseUrl.baseNext}/my-upgrade`"><button class="red-btn">马上续费</button></a></p>
                <p v-else><span class="fee-info">¥2499／年</span><a :href="`${baseUrl.baseNext}/my-upgrade`"><button class="red-btn">马上升级</button></a></p>
            </div>
            <div class="right">
                <div class="egg-num" v-if="user.isVip">
                    <p class="yellow-font">已获恐龙蛋奖励</p>
                    <p class="number yellow-font">{{reward}}</p>
                </div>
                <div class="egg-num" v-else>
                    <p class="yellow-font">升级获恐龙蛋</p>
                    <p class="number grey-font">60000</p>
                </div>
                <div class="egg-img">
                    <img src="../../../../images/vip/egg.png" alt="">
                </div>
            </div>
        </div>
        <div class="vip-cont">
            <div class="vip-item">
                <p class="item-title">会员专享</p>
                <div class="item-cont">
                    <div class="item-flex">
<!-- 
                        <div class="zxk-act act">
                            <a href="/my/personal/card/1">
                                <div class="link-a">查看详情</div>
                            <p>至尊住享卡</p>
                            <button class="red-btn" v-if="user.isVip">敬请期待</button>
                            <button class="disabled-btn" v-else>无权限</button>
                            </a>
                        </div> -->

                        <div class="act act-icon">
                            <div class="img">
                                <img src="../../../../images/vip/icon1.png" alt="">
                            </div>
                            <p>返利 60000 恐龙蛋</p>
                            <button class="disabled-btn" v-if="user.isVip">已享受</button>
                            <button class="disabled-btn" v-else>无权限</button>
                        </div>
                        <div class="act act-icon">
                            <div class="img">
                                <img src="../../../../images/vip/icon2.png" alt="">
                            </div>
                            <p>签到获双倍恐龙蛋</p>
                            <button class="disabled-btn" v-if="user.isVip">已享受</button>
                            <button class="disabled-btn" v-else>无权限</button>
                        </div>
                        <!-- <div class="act act-icon">
                            <div class="img">
                                <img src="../../../../images/vip/icon3.png" alt="">
                            </div>
                            <p>下单获双倍恐龙蛋</p>
                            <button class="disabled-btn" v-if="user.isVip">已享受</button>
                            <button class="disabled-btn" v-else>无权限</button>
                        </div> -->
                        <!-- <div class="act act-icon">
                            <div class="img">
                                <img src="../../../../images/vip/icon4.png" alt="">
                            </div>
                            <p>70000 恐龙蛋获色板册</p>
                            <button class="red-btn" @click="openColorCard" v-if="user.isVip">立即兑换</button>
                            <button class="disabled-btn" v-if="!user.isVip">无权限</button>
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="vip-item" v-if="user.isVip">
                <p class="item-title">奖励明细</p>
                <div class="item-cont">
                    <div class="list-table">
                        <p class="tb-header">
                            本月
                        </p>
                        <p class="tb-row" v-for="(item,index) in points" :key="index">
                            <span class="time">
                                {{item.createTime | setTimeDate}} {{item.createTime | setTime}}
                            </span>
                            <span class="cont">
                                {{item.changeTypeDisplay}}
                            </span>
                            <span class="ins red-font">
                                +{{item.changePoint}}
                            </span>
                        </p>
                    </div>
                    <div class="pages" v-show="points&&points.length > 0">
                        <Page :total="point.total" :page-size="point.filter.pageSize" @on-change="changePage"></Page>
                    </div>
                </div>
            </div>
            <div class="vip-item" v-if="false">
                <p class="item-title">会员续费</p>
                <div class="item-cont">
                    <div class="item-flex">
                        <div class="vip-card">
                            <p class="yellow-font">60000 恐龙蛋／年</p>
                            <button class="red-btn" v-if="user.isVip" @click="convertVip">立即兑换</button>
                            <button class="disabled-btn" v-else>无权限</button>
                        </div>
                        <div class="vip-card">
                            <p class="white-font">¥2499／年</p>
                            <button class="red-btn" v-if="user.isVip" @click="recharge">立即续费</button>
                            <button class="red-btn" v-else @click="recharge">马上升级</button>
                        </div>
                        <div class="vip-card">
                            <p class="white-font">
                                <span>输入兑换码</span>
                                <input  type="text" v-model="exchangeCode" maxlength="6">
                            </p>
                            <button class="red-btn" @click="exchangeByCode">立即兑换</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <color-card-dialog ref="colorCard" @exchangeSuc="exchangeSuc"></color-card-dialog>
        <upgrade-suc ref="upgradeSuc"></upgrade-suc>
        <exchange-suc ref="exchangeSucDlg"></exchange-suc>
        <egg-lack ref="eggLack" :text="text" :type="1"></egg-lack>
        <deduction-egg ref="deduction" @offerSubmit="offerSubmit"></deduction-egg>
        <delete-confirm ref="deleteConfirm"></delete-confirm>
    </div>
</template>
<script>
    import api from '../../../../api'
    import deductionEgg from '../../../common/deductionEgg.vue'
    import colorCardDialog from './colorCardDialog.vue'
    import upgradeSuc from './upgradeSuc.vue'
    import exchangeSuc from './exchangeSuc.vue'
    import eggLack from '../../../common/eggLack.vue'
    import deleteConfirm from '../../../common/deleteConfirm.vue'


    export default {
        data() {
            return {
                points: [],
                point: {
                    filter: {
                        pageSize: 10,
                        pageNum: 1,
                        type: 1
                    },
                    total: 0
                },
                exchangeCode: '',
                reward: 0,
                loaded: false,
                text: '恐龙蛋余额不足，无法兑换',
                baseUrl: {
                    baseOld: process.env.VUE_APP_OLD_BASIC_URL,
                    baseNext: process.env.VUE_APP_NEXT_BASIC_URL,
                    baseNuxt: process.env.VUE_APP_NUXT_BASIC_URL
                },
            }
        },
        components: {
            colorCardDialog,
            upgradeSuc,
            exchangeSuc,
            eggLack,
            deductionEgg,
            deleteConfirm
        },
        computed: {
            user() {
                this.getPoints();
                this.getReward();
                return this.$store.state.user.info;
            },
            balance() {
                return this.$store.state.app.balance
            }
        },
        methods: {
            changePage(val) {
                this.point.filter.pageNum = val;
                this.getPoints();
            },
            openColorCard() {
                if (this.balance < 70000) {
                    this.$refs.eggLack.open();
                } else {
                    this.$refs.colorCard.open();
                }
            },
            getPoints() {
                api.points.getPoints(this.point.filter)
                    .then((res) => {
                        this.points = res.list;
                        this.point.total = res.total;
                    });
            },
            getReward() {
                api.points.getReward()
                    .then((res) => {
                        this.reward = res;
                    });
            },
            exchangeSuc(color) {
                this.$store.dispatch('getBalance');
                this.$store.dispatch('getUser');
                if(color){
                    this.$refs.exchangeSucDlg.open('color');
                }else{
                    this.$refs.exchangeSucDlg.open();
                }
            },
            convertVip() {
                if (this.balance < 60000) {
                    this.$refs.eggLack.open();
                } else {
                    this.$refs.deduction.open('exchange', 60000);
                }
            },
            offerSubmit(){
                api.points.consumerPointsVip()
                    .then((res) => {
                        if (res) {
                            this.exchangeSuc();
                            this.$refs.deduction.cancel();
                        }
                    });
            },
            exchangeByCode() {
                if(!this.exchangeCode.trim()){
                    this.$refs.deleteConfirm.open({
                        text:'请输入兑换码！',
                        bigButton: 1
                    })
                }else{
                    api.points.exchangeByCode(this.exchangeCode)
                        .then((res) => {
                            if (res.result === false) {
                                this.$refs.deleteConfirm.open({
                                    text:res.message,
                                    bigButton: 1
                                })
                            }else{
                                this.exchangeCode = '';
                                this.exchangeSuc();
                            }
                        });
                }
            },
            recharge() {
                api.eggPurchase.pointOrrecharge({
                    amount:2499,
                    rechargeType:'member'
                })
                    .then(res => {
                        let id = res.orderId;
                        let type = '4'
                        this.$router.push({path: '/my/pay/choicePay/'+id+'/'+type + '?display=1' })
                    })
            },
        },
        mounted() {
            if (this.$route.query.showUpgrade == 1) {
                this.$refs.upgradeSuc.open();
            }
            this.$store.dispatch('getBalance')
        }
    }
</script>
<style scoped>
    .vip-header{
        height:302px;
        margin-bottom: 30px;
        background-image: url('../../../../images/vip/vip_head_bg.png');
    }

    .grey-font {
        color: #6C6F70;
    }

    .yellow-font {
        color: #F4D03C;
    }

    .white-font {
        color: #fff;
    }

    .left {
        float: left;
    }

    .right {
        float: right;
    }

    .vip-header > .left {
        margin-left: 56px;
        margin-top: 104px;
        text-align: left;
    }

    .vip-header > .left p.title {
        height: 50px;
        line-height: 50px;
    }

    .vip-header > .left p.due-time {
        font-size: 18px;
        color: #FFFFFF;
        opacity: 0.9;
        margin-top: 16px;
    }

    .vip-header > .left p .fee-info{
        font-size: 20px;
        color: #FFFFFF;
        opacity: 0.9;
        display:inline-block;
        margin-right:8px;
        vertical-align: middle;
        margin-top:10px;
    }

    .vip-header > .left p.title img {
        width: 38px;
        vertical-align: middle;
    }

    .vip-header > .left p.title span {
        font-size: 36px;
        color: #fff;
        display: inline-block;
        margin-left: 10px;
        vertical-align: middle;
    }
    .vip-header > .left button {
        margin-top: 10px;
        width: 112px;
        height: 32px;
        line-height: 32px;
    }

    .vip-header > .right {
        margin-right: 100px;
        display: flex;
        margin-top: 90px;
        height: 120px;
    }

    .vip-header > .right .egg-num {
        margin-right: 80px;
    }

    .vip-header > .right .egg-num .yellow-font {
        font-size: 14px;
        margin: 24px 0 18px;
        text-align: left;
    }

    .vip-header > .right .egg-num .number {
        font-size: 36px;
        line-height:42px;
        margin:0;
    }

    .vip-header > .right .egg-img {
        width: 116px;
    }

    button {
        border-radius: 100px;
        width: 95px;
        height: 32px;
        line-height: 32px;
    }

    button.disabled-btn {
        color: #6C6F70;
    }

    .vip-cont {
        padding: 0 50px;
    }

    .vip-cont .vip-item {
        margin-bottom: 30px;
    }

    .vip-cont .vip-item .item-title {
        font-size: 18px;
        line-height: 38px;
        text-align: left;
    }

    .vip-cont .vip-item .item-flex {
        text-align: left;
    }

    .vip-cont .vip-item .item-flex > div {
        display: inline-block;
        vertical-align: top;
    }

    .vip-cont .vip-item .item-flex .act {
        background: #fef3e0;
        border-radius: 8px;
        width: 164px;
        height: 224px;
        margin-right: 8px;
        margin-bottom: 12px;
        text-align: center;
    }

    .vip-cont .vip-item .act.zxk-act {
        background: #F5A623;
        border-radius: 8px;
        width:338px;
        position:relative;
    }
    .vip-cont .vip-item .act.zxk-act .link-a{
        font-size: 14px;
        color: #353838;
        position: absolute;
        right:16px;
        top:16px;
    }

    .vip-cont .vip-item .act.zxk-act p {
        font-size: 36px;
        color: #FFFFFF;
        margin: 74px 0 46px 0;
    }

    .vip-cont .vip-item .item-flex .act-icon .img {
        width: 116px;
        height: 120px;
        margin: 0 auto;
        margin-top: 24px;
        text-align: center;
    }

    .vip-cont .vip-item .item-flex .act-icon p {
        font-size: 14px;
        margin-bottom: 12px;
    }

    .vip-cont .vip-item .list-table {
        margin-bottom: 24px;
    }

    .vip-cont .vip-item .list-table .tb-header {
        background: #EBEFF0;
        font-size: 14px;
        color: #6C6F70;
        padding-left: 8px;
        text-align: left;
        line-height: 44px;
    }

    .vip-cont .vip-item .list-table .tb-row {
        line-height: 60px;
        border-bottom: 1px solid #DCE0E0;
        padding: 0 8px;
        text-align: left;
    }

    .vip-cont .vip-item .list-table .tb-row span {
        display: inline-block;
        font-size: 14px;
        vertical-align: middle;
    }

    .vip-cont .vip-item .list-table .tb-row span.time {
        margin-right: 214px;
    }

    .vip-cont .vip-item .list-table .tb-row span.cont {
        width: 164px;
        margin-right: 232px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .vip-cont .vip-item .list-table .tb-row span.ins {
        font-weight: bold;
    }

    .vip-cont .vip-item .vip-card {
        width: 232px;
        height: 320px;
        background-image: url('../../../../images/vip/vip_card_bg.png');
        padding-top: 200px;
        text-align: center;
        margin-left: 36px;
    }

    .vip-cont .vip-item .vip-card:first-child {
        margin-left: 0;
    }

    .vip-cont .vip-item .vip-card p {
        margin-bottom: 26px;
        font-size: 20px;
    }

    .vip-cont .vip-item .vip-card .red-btn {
        width: 95px;
        height: 32px;
        line-height: 32px;
    }

    .vip-cont .vip-item .vip-card p input {
        background: #EBEFF0;
        border-radius: 4px;
        border: 0 none;
        width: 114px;
        height: 30px;
        padding: 8px;
        color: #353838;
        font-size: 14px;
        margin-left: 4px;
    }
</style>
